import * as React from 'react';
import { Container } from 'reactstrap';
import { compose, setDisplayName } from 'recompose';
import './App.scss';
import AppRouter from './AppRouter';
import MainNavbar from './MainNavbar';
import * as poweredByStravaImage from './Strava/api_logo_pwrdBy_strava_horiz_light.svg';
import withAthlete from './Strava/withAthlete';

// Import font awesome styles.  By default they are injected into
// the page by script, but server-side rendering means that the glyphs
// are initially loaded unstyled, which makes them look huuuge.
// The injected styles are disabled by a global settings script in the
// html head.
import '../../../node_modules/@fortawesome/fontawesome/styles.css';

const enhance = compose(
    withAthlete,
    setDisplayName('App')
);

/**
 * Top level component for the application, both server and client side.
 * Preloads the current athlete details, if the user is logged in
 */
export default enhance(() => (
    <>
        <MainNavbar />
        <Container className="mt-1 mb-3">
            <div className="text-right mb-1">
                <a href="https://www.strava.com">
                    <img
                        className="powered-by-strava-image"
                        alt="Powered by Strava"
                        src={poweredByStravaImage}
                    />
                </a>
            </div>
            <AppRouter />
        </Container>
    </>
));



// WEBPACK FOOTER //
// ./src/client/components/App.tsx